import type { RouteRecordRaw } from 'vue-router'

export const stockTypesRoutes : RouteRecordRaw[] = [
    {
      path: '/stock_types',
      name: 'stockTypes',
      component: () => import('./views/StockTypesView.vue'),
      meta: {
          requiresAuth: true
      }
    }
]